// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {
    readLatestPerUnitMeasurements,
    resetLatestPerUnitMeasurements
} from '../../../../shared/action-creators/latest-per-unit-measurements';
import {
    updateJdpClaimInputOnBlur,
    updateJdpClaimProperty,
    updateResponsibleAccountsDropDown
} from './claim-details';
import actions from '../action-list';
import {canGetProductCustomer} from '../../../../shared/services/privacy';
import {doesAccountHaveMatch} from '../../../shared/services/claim-shared-helper';
import {getDetails} from '../../../../product/shared/repositories';
import {readCustomer} from './get-customer-details';
import {readLaborTypes} from '../../../shared/action-creators/labor-types';

const updateResponsibleAccount = (accountId, productAccountId, dealerCollection, dispatch) => {

    if (!accountId && doesAccountHaveMatch(productAccountId, dealerCollection)) {

        updateResponsibleAccountsDropDown(productAccountId, dealerCollection)(dispatch);
        dispatch(updateJdpClaimInputOnBlur('responsibleAccount', productAccountId));

    }

    if (accountId) {

        readLaborTypes(accountId)(dispatch);

    }

};

const updateCustomer = (product, dispatch) => {

    if (canGetProductCustomer(product)) {

        readCustomer(product.customerSummary.id, product.customerPrivate)(dispatch);

    }

};

export const readClaimProduct = pin =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);
            const accountId = getState().claims.spa.claim.responsibleAccount.account;
            const dealerCollection = getState().user.details.settings.dealer.accounts.allowedAccounts;

            dispatch({
                data,
                type: actions.SET_CLAIM_JDP_PRODUCT_DETAILS
            });

            if (!data.isNonTracked) {

                const productAccountId = data.dealer.account;

                dispatch(updateJdpClaimProperty('deliveryDate', data.deliveryDate));
                updateCustomer(data, dispatch);
                updateResponsibleAccount(accountId, productAccountId, dealerCollection, dispatch);
                dispatch(updateJdpClaimProperty('failurePartNumber', data.baseMachineCode));

            }

            readLatestPerUnitMeasurements(pin)(dispatch);

        } catch (error) {

            dispatch({
                type: actions.RESET_CLAIM_JDP_PRODUCT_DETAILS
            });

            resetLatestPerUnitMeasurements()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-creators/get-product-details.js